module.exports = __webpack_public_path__ + "7b296c81d3d4036c108052c70b7440f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/search-right.png
// module id = 1204
// module chunks = 0